<table class="table table-hover">
  <thead class="table-light">
    <tr>
      @for (column of columns; track column) {
        <th (click)="onColumnClick(column)">
          {{ column.label }}
          @if (column.tooltip) {
            <span matTooltip="{{ column.tooltip }}"> ? </span>
          }
        </th>
      }
    </tr>
  </thead>
  <tbody class="table-group-divider">
    @for (row of rows; track row; let i = $index) {
      <tr>
        @for (column of columns; track column) {
          <td>
            <!-- <span *ngIf="column.key === 'id'">
          <input type="checkbox" [value]="row.data.id" (change)="onCheckboxChange($event)" />
        </span> -->
            @if (column.key === 'date') {
              <span>
                <!-- row.data is an index map → unknown; $any unblocks the date pipe under
                     Angular 21 strict templates (pre-existing break from e3f409e62). -->
                {{ $any(row.data[column.key]) | date: 'shortDate' }}
              </span>
            }
            @if (column.key !== 'date' && column.key !== 'id') {
              <span>
                {{ row.data[column.key] }}
              </span>
            }
          </td>
        }
        <td>
          <button type="button" class="btn" (click)="onEditRow(row)">
            <i class="bx bx-pencil"></i>
          </button>
          <button type="button" class="btn" (click)="onDeleteRow(i)">
            <i class="bx bx-task-x"></i>
          </button>
        </td>
      </tr>
    }
  </tbody>
</table>
